import _ from 'lodash';
import { API } from '../config';

const parseData = (data: any) => {
	const dataRet = _.filter(data, obj => Object.prototype.hasOwnProperty.call(obj, 'stmomo'))
		.map(d => {
			if (parseInt(d.stmomo, 10) === 100) {
				d.tftf_90th = d.tftf;
				d.tftf_10th = d.tftf_tid;
				d.signal90_value = d.tftf_indicator;
				d.signal10_value = d.tftf_tid_indicator;
			} else if (parseInt(d.stmomo, 10) === -100) {
				d.tftf_90th = d.tftf_tid;
				d.tftf_10th = d.tftf;
				d.signal90_value = d.tftf_tid_indicator;
				d.signal10_value = d.tftf_indicator;
			}
			return d;
		});
	return dataRet;
};

export function getTable() {
	return fetch(`${API}/widgets/modeltable`, {
		headers: {},
		mode: 'cors',
	})
		.then(res => res.json())
		.then(res => parseData(res))
		.catch(error => error);
}
